import { CWC_2023 } from "./cwc-2023";
import { CWC_2022 } from "./cwc-2022";

export const CWC_DATASET = [CWC_2023, CWC_2022];
